import { Trip_AeroexpressSelectedTrip_Fragment } from '@websky/graphql';
import { DataLayerService } from '../OrderDataLayer/types';
import WebskyServicesAnalytics from '../WebskyServicesAnalytics';
import Base from './Base';
import { CheckoutCheckinOrder } from '../../DataLayerAnalytics/types';
import { Diff } from './types';

class Aeroexpress extends Base {
	protected orderBeforeChange: CheckoutCheckinOrder;
	protected orderAfterChange: CheckoutCheckinOrder;

	constructor(orderBeforeChange: CheckoutCheckinOrder, orderAfterChange: CheckoutCheckinOrder) {
		super(orderBeforeChange, orderAfterChange);
	}

	public diff(): Diff {
		const added: DataLayerService[] = [];
		const removed: DataLayerService[] = [];

		const { added: aeroexpressAdded, removed: aeroexpressRemoved } = this.getTravellersServicesDiff<
			Trip_AeroexpressSelectedTrip_Fragment
		>(
			this.orderBeforeChange?.additionalServices?.transfer?.aeroexpress?.selectedTrips,
			this.orderAfterChange?.additionalServices?.transfer?.aeroexpress?.selectedTrips,
			service => service.id
		);
		added.push(...WebskyServicesAnalytics.aeroexpress(aeroexpressAdded, this.orderAfterChange?.travellers ?? []));
		removed.push(
			...WebskyServicesAnalytics.aeroexpress(aeroexpressRemoved, this.orderAfterChange?.travellers ?? [])
		);

		return { added, removed };
	}
}

export default Aeroexpress;
